/** 독서 상태 — 기존 문서에는 이 필드가 없으므로 읽을 때 'reading' 으로 간주한다. */
export const BOOK_STATUS = {
  READING: 'reading',
  WANT: 'want',
  ARCHIVED: 'archived',
  COMPLETED: 'completed',
  PAUSED: 'paused'
};

export const BOOK_STATUS_LIST = [
  { value: BOOK_STATUS.READING, label: '읽는 중' },
  { value: BOOK_STATUS.WANT, label: '읽고 싶은' },
  { value: BOOK_STATUS.ARCHIVED, label: '보관함' },
  { value: BOOK_STATUS.COMPLETED, label: '완독' },
  { value: BOOK_STATUS.PAUSED, label: '중단' }
];

export const BOOK_STATUS_LABEL = BOOK_STATUS_LIST.reduce((acc, s) => {
  acc[s.value] = s.label;
  return acc;
}, {});

/** status 가 없는 레거시 문서를 위한 정규화 */
export const getBookStatus = (book) => book?.status || BOOK_STATUS.READING;
